import React, { useCallback } from "react";
import { Checkbox, Tooltip } from "@material-ui/core";
import FormFieldBox from "../DesignSystem/formFieldBox";
import Input from "../DesignSystem/input";
import Dropdown from "../DesignSystem/dropdown";
import DropdownAuto from "../DesignSystem/dropdown_autocomplete";
import Textarea from "../DesignSystem/textarea";
import InfoIcon from "../../assets/images/info-icon.svg";
import PortInfoForm from "./portInfoForm";
import CheckboxIcon from "../../assets/images/checkbox-unchecked.svg";
import CheckboxCheckedIcon from "../../assets/images/checkbox-checked.svg";
import WaveXchangeIcon from "../../assets/images/wavexchange-small-icon.svg";

interface AddPortFormProps {
  networkElementOptions: any[];
  portTypeOptions: any[];
  selectedNetworkElement: any;
  portDescription: string;
  noOfPortsToAdd: number | string;
  noOfPortsError: string;
  portsInfo: any[];
  selectedPortType: number;
  verifyPorts: boolean;
  onNetworkElementChange: (value: any) => void;
  onPortDescriptionChange: (_: any) => void;
  onNoOfPortsChange: (_: any) => void;
  onKeypress: (_: any) => void;
  onPortTypeChange: (portTypeId: number) => void;
  onPortNameChange: (portTempId: number, portName: string) => void;
  handleVerifyChange: () => void;
  inputValue: string;
  onInputChange: (_: string) => void;
  GroupDropdownProps: any;
  portPrefix: string;
  handlePortPrefixChange: (_: string) => void;
}

const AddPortForm: React.FC<AddPortFormProps> = ({
  inputValue,
  onInputChange,
  verifyPorts,
  networkElementOptions,
  selectedNetworkElement,
  portTypeOptions,
  portsInfo,
  portDescription,
  noOfPortsToAdd,
  noOfPortsError,
  handleVerifyChange,
  onKeypress,
  onNetworkElementChange,
  onPortDescriptionChange,
  onNoOfPortsChange,
  selectedPortType,
  onPortTypeChange,
  onPortNameChange,
  GroupDropdownProps,
  portPrefix,
  handlePortPrefixChange,
}) => {
  const portInfoContent = portsInfo.map((portInfo: any, index: number) => {
    return (
      <PortInfoForm
        key={index}
        portInfo={portInfo}
        onPortNameChange={onPortNameChange}
        onKeypress={onKeypress}
        IsPortNameValid={GroupDropdownProps.IsPortNameValid}
      />
    );
  });
  const handlePortTypeChange = useCallback(
    (value: any) => {
      onPortTypeChange(parseInt(value));
    },
    [onPortTypeChange]
  );
  const organizationId = parseInt((localStorage.getItem("org_id") && localStorage.getItem("org_id")) || "0");

  return (
    <div className="form-section-root">
      <div className="upper-section">
        <FormFieldBox excludeMarginTop excludeMarginBottom>
          <label>
            Select Location
            <span className="asterisk">*</span>
          </label>
          <DropdownAuto
            inputValue={inputValue}
            onInputChange={onInputChange}
            value={selectedNetworkElement.ne_name || ""}
            onNetNames={networkElementOptions.filter((item: any) => item.on_net).map((item: any) => item.ne_name)}
            options={networkElementOptions.map((item: any) => item.ne_name)}
            onChange={onNetworkElementChange}
          />
        </FormFieldBox>
        <div className="upper-fields">
          <div className="left-section">
            <FormFieldBox excludeMarginTop excludeMarginBottom>
              <div className="text-area-root">
                <div>
                  <label>
                    No. of Port to be added
                    <span className="asterisk">*</span>
                  </label>
                  <Tooltip
                    classes={{
                      tooltip: "tooltip",
                    }}
                    title="Enter the integer number of ports to be added which share a common description. When adding more that one port, ports will be automatically grouped on the dashboard page."
                    arrow
                    placement="right-start"
                  >
                    <img src={InfoIcon} alt="Info" />
                  </Tooltip>
                </div>
                <div>
                  <Input
                    variant="number"
                    name="no-of-ports"
                    value={noOfPortsToAdd}
                    min={1}
                    className="no-of-ports-input"
                    errorMessageClass="small-fonts"
                    onChange={onNoOfPortsChange}
                    error={!!noOfPortsError}
                    errorMessage={noOfPortsError}
                  />
                </div>
              </div>
            </FormFieldBox>
          </div>
          <div className="right-section">
            <FormFieldBox excludeMarginTop excludeMarginBottom>
              <div className="port-type-div">
                <label>
                  Port Type
                  <span className="asterisk">*</span>
                </label>
                <Tooltip
                  classes={{
                    tooltip: "tooltip",
                  }}
                  title="Choose the Port Interface Type."
                  arrow
                  placement="top"
                >
                  <div className="img-div">
                    <img src={InfoIcon} alt="Info" />
                  </div>
                </Tooltip>
              </div>
              {portTypeOptions && portTypeOptions.length > 0 && selectedPortType && (
                <Dropdown
                  className="ne-select"
                  value={selectedPortType}
                  valueKey="id"
                  textKey="port_type"
                  icon="icon"
                  options={portTypeOptions}
                  onChange={handlePortTypeChange}
                />
              )}
            </FormFieldBox>
          </div>
        </div>
      </div>
      <FormFieldBox excludeMarginTop excludeMarginBottom>
        <div className="text-area-root">
          <div>
            <label>
              Group
              <span className="asterisk">*</span>
            </label>
            <Tooltip
              classes={{
                tooltip: "tooltip",
              }}
              title="Select An Existing Group or Add A New Group"
              arrow
              placement="right"
            >
              <img src={InfoIcon} alt="Info" />
            </Tooltip>
          </div>
          <div>
            {/* <Input
              variant="input"
              name="port-description"
              className="port-description"
              value={portDescription}
              onChange={onPortDescriptionChange}
              onKeypress={onKeypress}
            /> */}
            {GroupDropdownProps.dropdownComponent}
          </div>
        </div>
      </FormFieldBox>
      {selectedNetworkElement.on_net && selectedNetworkElement.leased_organization !== organizationId ? (
        <FormFieldBox excludeMarginTop excludeMarginBottom>
          <div className="verify-checkbox">
            <div>
              <Checkbox
                classes={{
                  root: "selection-checkbox",
                }}
                color="default"
                checked={verifyPorts}
                onChange={handleVerifyChange}
                icon={<img src={CheckboxIcon} alt="Checkbox" className="checkbox-icon" />}
                checkedIcon={<img src={CheckboxCheckedIcon} alt="Checkbox Checked" className="checkbox-checked-icon" />}
                inputProps={{
                  // @ts-ignore
                  "data-testid": "checkbox-input",
                }}
                data-testid="checkbox"
              />
              <label>Move to WaveXchange</label>
            </div>
            <div>
              <Tooltip
                classes={{
                  tooltip: "tooltip",
                }}
                title="The selected location is manageable in real-time by WaveXchange Software. Click the checkbox to the left to request for your ports to be verified."
                arrow
                placement="right"
              >
                <img src={WaveXchangeIcon} alt="Info" />
              </Tooltip>
            </div>
          </div>
        </FormFieldBox>
      ) : null}
      <FormFieldBox excludeMarginTop excludeMarginBottom>
        <div className="text-area-root">
          <div>
            <label>
              Port Prefix
              <span className="asterisk">*</span>
            </label>
            <Tooltip
              classes={{
                tooltip: "tooltip",
              }}
              title="Enter the integer number of ports to be added which share a common description. When adding more that one port, ports will be automatically grouped on the dashboard page."
              arrow
              placement="right-start"
            >
              <img src={InfoIcon} alt="Info" />
            </Tooltip>
          </div>
          <div>
            <Input variant="input" value={portPrefix} errorMessageClass="small-fonts" onChange={handlePortPrefixChange} name="prefix" onKeypress={onKeypress} />
          </div>
        </div>
      </FormFieldBox>
      <FormFieldBox excludeMarginTop>
        <div className="port-info-titles">
          <div className="port-name-label">
            <label>
              Port
              <span className="asterisk">*</span>
            </label>
            <Tooltip
              classes={{
                tooltip: "tooltip",
              }}
              title="Enter a unique identifier for each individual port. Example: “Port #1”"
              arrow
              placement="top"
            >
              <img src={InfoIcon} alt="Info" />
            </Tooltip>
          </div>
          {portInfoContent}
        </div>
      </FormFieldBox>
    </div>
  );
};

export default AddPortForm;
